/**
 * interface for general app settings
 */
export class AppSettings {
    constructor() {
        this.MULTI_MODALITY = [];
    }
}
//# sourceMappingURL=appSettings.interface.js.map